

class StringHelper
{
    /**
     * Set first letter in upper case
     */
    capitalize(str){
        str+='';
        return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    }

    /**
     * Translate accent to not accent
     * @ see : https://stackoverflow.com/questions/990904/remove-accents-diacritics-in-a-string-in-javascript
     */
    normalize(str){
        return str.toString().normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLowerCase();
    }

    /**
     * Compare 2 strings mormalized (accent translated) and lower case
     */
    compareNormalize(str1,str2){
        return this.normalize(str1)===this.normalize(str2);
    }

    /**
     * Search needle in to  mormalized strings (accent translated) and lower case
     */
    searchNormalize(needle,str,noSpace=false){

        if(noSpace){
            needle=needle.split(' ').join('');
            str=str.toString().split(' ').join('');
        }

        return this.normalize(str).indexOf(this.normalize(needle)) >= 0;
    }

    /**
     * return "s" for plural
     */
    pluriel(number){
        return Math.abs(number)>1 ? 's' : '';
    }

    /**
     * format numss to X XX XX XX XXX XXX
     */
    formatSSNum(ssnum){

        if(!ssnum) return '';

        return this.unformatSSNum(ssnum.toString())
            .split(/^([0-9]{1})?([0-9]{2})?([0-9]{2})?([0-9A-z]{2})?([0-9]{3})?([0-9]{3})?(.*)?/)
            .filter(function (el) { return el != null && el !== undefined && el !== '';})
            .join(' ');
    }

    /**
     * return ss unformated
     */
    unformatSSNum(ssnum){
        return ssnum.toString().replace(/\s/gi,'');
    }

    removeSSNumSpaces(ssnum) {
        return ssnum.replace(' ', '');
    }

    /**
     * formattel to +XXX XX XX XX XX
     */
    formatTelInter(tel){
        return tel.toString().split(/^(\+[0-9]{3})?([0-9]{2})?([0-9]{2})?([0-9]{2})?([0-9]{2})?(.*)?/)
            .filter(function (el) { return el != null && el !== undefined && el !== '';})
            .join(' ');
    }

    /**
     * formattel to 0X XX XX XX XX
     */
    formatTel(tel){
        return tel.toString().split(/^([0][0-9])?([0-9]{2})?([0-9]{2})?([0-9]{2})?([0-9]{2})?(.*)?/)
            .filter(function (el) { return el != null && el !== undefined && el !== '';})
            .join(' ');
    }


    /**
     * format money to x xxx xxx,xx
     */
    formatMoney(money,field=true){

        money = money.toString();

        // Remove other chars
        // eslint-disable-next-line no-useless-escape
        money = money.replace(/[^\.^,^+^\-^0-9]/g,'');

        if(!money) return '';

        var option = { maximumFractionDigits: 2,minimumFractionDigits : 2 }

        if(field===true){

            // If end with , or . (and end with 0) special case to not remove them
            // eslint-disable-next-line no-useless-escape
            if(/[\.,][0-9]?$/g.test(money)){
                // eslint-disable-next-line no-useless-escape
                return money.replace(/[\.,]/g,',');
            }

            money = this.unformatMoney(money);

            // eslint-disable-next-line no-useless-escape
            if(!/[\.,][0-9]{2,3}$/g.test(money)){
                option = {};
            }
        }

        return parseFloat(money).toLocaleString("fr-FR", option).replace(/ |\s/g,' ');
    }

    /**
     * return money unformated
     */
    unformatMoney(money){
        if(!money) return '';

        return money.toString().replace(",", ".").replace(/\s/g, "");
    }

}

/**********
 * EXPORT *
 **********/

export default new StringHelper();